<script>
import CarUseForm from '@views/reports/car-use-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    CarUseForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    reportId: {
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(carUse) {
      this.setUnchanged();
      this.$emit('updated', carUse);
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.carUseModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal ref="carUseModal" v-model="showModal" size="lg" hide-footer :title="$t('titles.edit_car_use')" static @hide="hide" @hidden="$emit('hidden')">
    <CarUseForm v-if="showModal" :loaded-id="loadedId" :report-id="reportId" @submitted="submit" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
